import React, { useState } from "react";
import { Card, Form, Input, Button } from "antd";
import useAuth from "../hooks/useAuth"; // Import useAuth hook

function Login() {
  const [formError, setFormError] = useState(false);
  const { login, loading } = useAuth(); // Destructure login from useAuth

  const onFinish = async (values) => {
    setFormError(false);

    login(values);
  };

  const onFinishFailed = (errorInfo) => {
    setFormError(true);
  };

  return (
    <div className="text-center mt-24">
      <Card className="w-96 mx-auto p-8">
        <h2 className="text-2xl mb-4">Iniciar Sesión</h2>
        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className={formError ? "border-red-500" : ""}
        >
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Por favor ingrese su nombre de usuario!",
              },
            ]}
          >
            <Input placeholder="Nombre de usuario" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Por favor ingrese su contraseña!" },
            ]}
          >
            <Input.Password placeholder="Contraseña" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading.post}>
              Iniciar Sesión
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default Login;
